module.exports = __webpack_public_path__ + "img/graduate.755ed206.svg";